export default {  
    "dlabel_upload": "Subir",
    "dlabel_view": "Vista",
    "dlabel_edit": "Editar",
    "dlabel_delete": "Borrar",
    "dlabel_delete_upload": "Eliminar carga",
    "dlabel_display_file": "Archivo de visualización",
    "dlabel_dd_img": "¡Arrastra y suelta la imagen aquí!",
    "dlabel_status": "Status",
    "dlabel_active": "Activo",
    "dlabel_inactive": "Inactivo",   
    "dlabel_orientation": "Orientación", 
    "dlabel_security_pin": "PIN de Seguridad",
    "dlabel_start_date": "Fecha de inicio",
    "dlabel_end_date": "Fecha final",
    "dlabel_form_dis": "Pantalla de formulario",
    "dlabel_save": "Guardar",
    "dlabel_cancel": "Cancelar",
    "dlabel_template": "Plantilla",
    "dlabel_name": "Nombre",   
    "dlabel_setting": "Configuración",
    "dlabel_gnral_setting": "Ajustes generales",
    "dlabel_back": "Atrás",         
    "dmsj_file_exceeds": "El archivo supera los 20 megabytes",
    "dmsj_delete_dis": "Eliminar pantalla?",
    "dmsj_ar_yu_sr": "Estas seguro?",
    "dmsj_delete_it": "Sí, eliminarlo!",
    "dmsj_greater_than_digits": "solo puede tener más de 6 dígitos.",
    "dmsj_security_pin_empty": "El campo del PIN de seguridad no puede estar vacío, debe tener al menos 6 dígitos.",  
    "dmsj_send_data": "Enviar datos",
    "dmsj_successful": "Exitosa",   
    "dmsj_empty_file": "Archivo vacío",  
}